import React from 'react'
import moment from 'moment-timezone'
import { TableCell } from 'transfix-ui/components/Table'

interface IPropsCreatedAtTableCell {
  createdAt: string
}

export const CreatedAtTableCell = ({ createdAt }: IPropsCreatedAtTableCell) => {
  return (
    <TableCell>
      {/* TODO: check & adjust parsing to account for timezone */}
      {moment(createdAt).fromNow()}{' '}
      <p className='text-small'>
        {/* TODO: use existing time formatter or add this one to datetime.ts */}(
        {moment(createdAt).format('MMMM Do YYYY, h:mm:ss A')})
      </p>
    </TableCell>
  )
}

interface IPropsPartnerTableCells {
  partnerApplicationType: string
  partnerApplicationId: number
}

export const PartnerTableCells = ({
  partnerApplicationId,
  partnerApplicationType,
}: IPropsPartnerTableCells) => {
  const partnerType = partnerApplicationType === 'ShipperApplication' ? 'shipper' : 'carrier'
  return (
    <>
      <TableCell className='ttc'>{partnerType}</TableCell>
      <TableCell>
        <a href={`/${partnerType}s/${partnerApplicationId}`}>{partnerApplicationId}</a>
      </TableCell>
    </>
  )
}

interface IPropsShipmentTableCell {
  shipmentId?: number
}

export const ShipmentTableCell = ({ shipmentId }: IPropsShipmentTableCell) => {
  return (
    <TableCell>
      {!!shipmentId && (
        <a
          href={`${__ROOT__}/shipment-details/${shipmentId}?tab=scheduling`}
          target='_blank'
          rel='noopener noreferrer'>
          {shipmentId}
        </a>
      )}
    </TableCell>
  )
}
